import { Yup } from 'src/helpers/Yup';
import { validateCPF } from 'src/helpers/cpf';
import { validateDateFromBrazilianForm } from 'src/helpers/Date';

export const ProfessionalAndPersonalDataSchema = Yup.object().shape({
  document: Yup.string()
    .required('Informe um número de CPF válido.')
    .test('validate cpf', 'Informe um número de CPF válido.', function (document) {
      return validateCPF(document || '');
    }),
  fullName: Yup.string().required('Informe seu nome completo.'),
  birthDate: Yup.string()
    .required('Informe uma data de nascimento válida.')
    .test('match', 'Informe uma data de nascimento válida.', (birthDate) => {
      return validateDateFromBrazilianForm(birthDate);
    }),
  counsel: Yup.string().required('Informe o conselho profissional.'),
  UFRegister: Yup.string().required('Informe uma UF do Registro válida.'),
  registerNumber: Yup.string()
    .required('Informe um Número de Registro válido.')
    .matches(/^(NX(\d){1,5}|(\d){1,7})$/i, 'Informe um Número de Registro válido.'),
});
